import {
  AutocompleteInput,
  minValue,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  useSimpleFormIteratorItem,
} from "react-admin";
import { useWatch } from "react-hook-form";
import { Grid } from "@mui/material";

import { studentRequests } from "api/studentApi";

const DisciplineFields = ({ curriculumId, watchPrefix }) => {
  const disciplineId = useWatch({ name: `${watchPrefix}.disciplineId` });

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="disciplineId"
          reference={studentRequests.getCurriculumDisciplinesSelect(curriculumId)}
        >
          <AutocompleteInput
            label="Дисциплина"
            optionText="name"
            fullWidth
            validate={required()}
            filterToQuery={q => (q?.length > 2 ? { disciplineName: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      {disciplineId ? (
        <Grid
          item
          xs={12}
          md={3}
        >
          <ReferenceInput
            source="semester"
            reference={studentRequests.getCurriculumDisciplineSemestersSelect(curriculumId, disciplineId)}
          >
            <SelectInput
              label="Семестър"
              optionText="name"
              optionValue="id"
              fullWidth
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
      ) : null}
      <Grid
        item
        xs={12}
        md={3}
      >
        <NumberInput
          source="studyGroup"
          label="Учебна група"
          fullWidth
          min={1}
          validate={[required(), minValue(1)]}
          onWheel={e => e.target.blur()}
        />
      </Grid>
    </Grid>
  );
};

export const DisciplineIteratorItem = ({ curriculumId, source = "disciplines" }) => {
  const { index } = useSimpleFormIteratorItem();

  return (
    <DisciplineFields
      curriculumId={curriculumId}
      watchPrefix={`${source}.${index}`}
    />
  );
};

export default DisciplineFields;
